import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { getCountryOptions } from '../utils/countryOptions';

const ReactSelectCountries = ({ options = [], placeholder, ...props }) => (
  <ReactSelectInput
    options={isEmpty(options) ? getCountryOptions() : options}
    placeholder={placeholder || I18n.t('global.country')}
    {...props}
  />
);

ReactSelectCountries.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default ReactSelectCountries;
